var _defs, _path, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurrps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 724 742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#007aff;}.b{fill:#1b1464;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M158.64,0H46.36A46.37,46.37,0,0,0,0,46.36V158.64A46.37,46.37,0,0,0,46.36,205H158.64A46.37,46.37,0,0,0,205,158.64V46.36A46.37,46.37,0,0,0,158.64,0Zm-7.32,126.54A25.29,25.29,0,0,1,126,151.83H78.46a25.29,25.29,0,0,1-25.29-25.29V79A25.29,25.29,0,0,1,78.46,53.68H126A25.29,25.29,0,0,1,151.32,79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M425.64,0H313.36A46.37,46.37,0,0,0,267,46.36V158.64A46.37,46.37,0,0,0,313.36,205H425.64A46.37,46.37,0,0,0,472,158.64V46.36A46.37,46.37,0,0,0,425.64,0Zm-7.32,126.54A25.29,25.29,0,0,1,393,151.83H345.46a25.29,25.29,0,0,1-25.29-25.29V79a25.29,25.29,0,0,1,25.29-25.29H393A25.29,25.29,0,0,1,418.32,79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M158.64,271H46.36A46.37,46.37,0,0,0,0,317.36V429.64A46.37,46.37,0,0,0,46.36,476H158.64A46.37,46.37,0,0,0,205,429.64V317.36A46.37,46.37,0,0,0,158.64,271Zm-7.32,126.54A25.29,25.29,0,0,1,126,422.83H78.46a25.29,25.29,0,0,1-25.29-25.29V350a25.29,25.29,0,0,1,25.29-25.29H126A25.29,25.29,0,0,1,151.32,350Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 245,
    y: 263,
    width: 479,
    height: 479,
    rx: 87.34
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurrps);
export default __webpack_public_path__ + "static/media/purrps.d8162085.svg";
export { ForwardRef as ReactComponent };